module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0085.jpg?v=9f7524cc";